import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Instagram, Twitter } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { imgUrl } from '../lib/utils';
import theme from '../theme.config';
const SITE_LOGO = theme.assets.logo;

export const Footer = () => {
  const { store, isReseller } = useStore();
  const storeName = isReseller ? store?.store_name || 'Store' : theme.brand.name;
  const logoSrc = isReseller && store?.logo_url ? imgUrl(store.logo_url) : SITE_LOGO;
  return (
    <footer className="border-t border-primary/20 mt-auto" style={{ background: 'hsl(var(--card))', boxShadow: '0 -1px 0 0 hsl(var(--primary) / 0.1)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={logoSrc} alt={storeName} className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-md font-mono leading-relaxed">
              {theme.copy.footer.tagline}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-8 h-8 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-secondary hover:border-secondary/50 transition-all">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-mono text-xs text-primary uppercase tracking-widest mb-4">▸ Layanan</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-muted-foreground hover:text-primary text-sm transition-colors font-mono">Top Up Game</Link></li>
              <li><Link to="/" className="text-muted-foreground hover:text-primary text-sm transition-colors font-mono">Voucher Digital</Link></li>
              <li><Link to="/track" className="text-muted-foreground hover:text-primary text-sm transition-colors font-mono">Cek Transaksi</Link></li>
              <li><Link to="/reseller" className="text-muted-foreground hover:text-secondary text-sm transition-colors font-mono">Program Reseller</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-mono text-xs text-secondary uppercase tracking-widest mb-4">▸ Informasi</h4>
            <ul className="space-y-2">
              <li><Link to="/page/tentang-kami" className="text-muted-foreground hover:text-white text-sm transition-colors font-mono">Tentang Kami</Link></li>
              <li><Link to="/page/kebijakan-privasi" className="text-muted-foreground hover:text-white text-sm transition-colors font-mono">Kebijakan Privasi</Link></li>
              <li><Link to="/page/syarat-ketentuan" className="text-muted-foreground hover:text-white text-sm transition-colors font-mono">Syarat & Ketentuan</Link></li>
              <li><Link to="/page/hubungi-kami" className="text-muted-foreground hover:text-white text-sm transition-colors font-mono">Hubungi Kami</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-xs font-mono">
            © 2026 {isReseller ? storeName : theme.brand.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="font-mono text-[10px] text-primary tracking-widest uppercase">REACTOR_PRESSURE_NOMINAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
